function fn_part_filter() {
    var $part = $(".part_filter");
    // $part.find("[data-filter-toggle]").on("click",function(e){
    //     e.preventDefault();
    //     $(this).toggleClass("active").next(".filter").toggleClass("active").slideToggle(500);
    // });
    nl_fn_switch_content($part.find("[data-switch-filter]"),1);


    if($part.find("[data-switch-filter] [type=checkbox]").is(':checked')) {
        $("[data-switch-filter]").find(".filter_bottom").show().addClass("toggle");
    }

    $part.find("[data-switch-filter] [type=checkbox]:checked").each(function(){
        var label = $(this).next("label").find("i").text();
        var label_id = $(this).attr("id");
        $("[data-filter-bottom-labels]").append('<label class="label" data-id="'+label_id+'"><span class="icon icon-close"></span>&nbsp;<i>'+label+'</i></label>').find(".label:last-of-type").hide().fadeIn(500);
    });

    $part.find("[data-switch-filter] input[type=checkbox]").change(function () {
        if($part.find("[data-switch-filter] [type=checkbox]").is(':checked')) {
            $("[data-switch-filter]").find(".filter_bottom").stop(true, true).slideDown(500).addClass("toggle");
        } else {
            $("[data-switch-filter]").find(".filter_bottom").stop(true, true).slideUp(500).removeClass("toggle");
        }
    });

    $part.find("[data-switch-filter] input[type=checkbox]").change(function () {
        var label = $(this).next("label").find("i").text();
        var label_id = $(this).attr("id");
        if($(this).is(':checked')) {
            $("[data-filter-bottom-labels]").append('<label class="label" data-id="'+label_id+'"><span class="icon icon-close"></span>&nbsp;<i>'+label+'</i></label>').find(".label:last-of-type").hide().fadeIn(500);
        } else {
            $("[data-filter-bottom-labels]").find(".label[data-id="+label_id+"]").remove();
        }
    });
    $(document).on("click","[data-filter-bottom-labels] .label", function(){
        $(this).remove();
        var label_id = $(this).data("id");
        $("[data-switch-filter] input[id="+label_id+"]").prop('checked', false);
        if (!$("[data-filter-bottom-labels] .label").length) {
            $("[data-switch-filter]").find(".filter_bottom").stop(true, true).slideUp(500).removeClass("toggle");
        }
    });
    $part.find("[data-filter-reset]").on("click",function(e){
        e.preventDefault();
        $("[data-switch-filter] input[type=checkbox]").prop('checked', false);
        $("[data-filter-bottom-labels]").html("");
        $("[data-switch-filter]").find(".filter_bottom").stop(true, true).slideUp(500).removeClass("toggle");
    });
}